import { Component, OnInit } from '@angular/core';
import { UserService, ContextService, CommandeService } from '../../shared';
import { EnteteCommande } from '../../shared';
import { environment } from '../../../environments/environment';
@Component({
  selector: 'app-ressources',
  templateUrl: './ressources.component.html',
  styleUrls: ['./ressources.component.scss'],
  providers: [ UserService ]
})
export class RessourcesComponent implements OnInit {

  context: string;
  ressources: Array<any> = [];
  message: string;
  imgfolder_url: string;

  constructor(
  	private userService: UserService,
    private contextService: ContextService,
  ) { }

  ngOnInit() {
    this.imgfolder_url=environment.imgfolder_url;
    this.context = this.contextService.getContext();

    this.userService.getAllRessources()
      .subscribe(
        data => {
          this.ressources = data;
          console.log(data)  
        },
        error => {
           this.message=error[0].Message
          if(error[0].Code == 'COMMANDE_NON_TROUVE'){
            this.ressources = [];
          }
        }
      );
  }



}



// WEBPACK FOOTER //
// ./src/app/user/_ressources/ressources.component.ts